import type { ReactNode } from "react";

/**
 * Shared "nothing here yet" placeholder. Used by DataTable, drawer
 * bodies, and any list that resolves to zero rows.
 */

export interface EmptyStateAction {
  label: string;
  onClick: () => void;
}

export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: EmptyStateAction;
}

export function EmptyState({
  title,
  description,
  icon,
  action,
}: EmptyStateProps) {
  return (
    <div
      role="status"
      aria-label={title}
      className="flex flex-col items-center gap-3 px-6 py-12 text-center text-fc-text-dim"
    >
      {icon ? (
        <div className="flex h-10 w-10 items-center justify-center rounded-fc-card border border-fc-border bg-fc-overlay text-fc-text-secondary">
          {icon}
        </div>
      ) : null}
      <p className="text-[15px] font-semibold text-fc-text">{title}</p>
      {description ? (
        <p className="max-w-sm text-[13px] leading-relaxed text-fc-text-dim">
          {description}
        </p>
      ) : null}
      {action ? (
        <button
          type="button"
          onClick={action.onClick}
          className="mt-1 rounded-fc-sm border border-fc-border px-3 py-1.5 text-[13px] text-fc-text transition hover:border-fc-brand hover:text-fc-brand"
        >
          {action.label}
        </button>
      ) : null}
    </div>
  );
}
